import api from './apiClient';

export const posAPI = {
  getAgentEvents: (agentId) => api.get('/pos/events', { params: { agentId } }),
  getAgentStats: (agentId, eventId) => api.get(`/pos/events/${eventId}/stats`, { params: { agentId } }),
  sellTicket: (data) => api.post('/pos/sell', data),

  getSaleAgents: () => api.get('/pos/agents'),
  assignAgent: (data) => api.post('/pos/assignments', data),
  getAgentAllocations: (agentId) => api.get(`/pos/agents/${agentId}/allocations`),
};

export default posAPI;

